export default __webpack_public_path__ + "static/media/Image.f01a3c3b.png";